module.exports = __webpack_public_path__ + "static/media/setup-loading.821911c2.gif";